export default {
  en_US: {
    'breadcrumbs.home': 'Home',
    'breadcrumbs.products': 'Products',
    'breadcrumbs.articles': 'Articles',
    'breadcrumbs.about': 'About us',
    'breadcrumbs.contact': 'Contact Us',
    'breadcrumbs.seller': 'Order',
    'navigation.home': 'Home',
    'navigation.products': 'Products',
    'navigation.articles': 'Articles',
    'navigation.about': 'Our brand',
    'navigation.contact': 'Contact Us',
    'navigation.tel': 'Tel',
    'home.title.1': 'We Are Healthcare Experts',
    'home.title.2': '',
    'home.readmore.button': 'Read more',
    'home.products.label': 'Products',
    'home.products.view.all.button': 'View all products',
    'home.articles.label': 'Healthy tips and tricks',
    'home.articles.view.all.button': 'View all articles',
    'standard.label': 'Manufacturing Facility Certification',
    'seller.label': 'Clover Plus is now available at',
    'products.all.products.label': 'All products',
    'products.loadmore.button': 'Load More',
    'products.seller.button': 'Buy',
    'products.fda.label': 'FDA No.',
    'products.related.products.label': 'Related products',
    'products.no.related.products.label': 'No related products found',
    'sellers.title': 'Available at',
    'article.read.more.button': 'Read more',
    'articles.label': 'Healthy tips and tricks',
    'articles.loadmore.button': 'Load More',
    'articles.related.articles': 'Related articles',
    'articles.no.related.articles': 'No related articles found',
    'contact.title': 'Contact us',
    'contact.tel': 'Tel',
    'contact.email': 'Email',
    'contact.join.us': 'If you would like to be our partner, please contact',
    'quill.cannot.upload.image': 'Cannot upload the image',

    'snackbar.ok.text': 'Okay',
    'snackbar.error.message': 'An error occurs',

    'backoffice.navigation.signout': 'Sign out',

    'backoffice.sidebar.title': 'ADJUSTMENT',
    'backoffice.sidebar.articles': 'Blog',
    'backoffice.sidebar.articles.add': 'Add Content',
    'backoffice.sidebar.about': 'About',
    'backoffice.sidebar.contact': 'Contact Us',
    'backoffice.sidebar.seller': 'Stores',
    'backoffice.sidebar.category': 'Categories',
    'backoffice.sidebar.products': 'Adjust Product',
    'backoffice.sidebar.products.all': 'All Product',
    'backoffice.sidebar.products.add': 'Add Product',
    'backoffice.sidebar.products.edit': 'Edit',
    'backoffice.sidebar.orders.all': 'All Order',
    'backoffice.sidebar.orders.edit': 'Edit Order Fordm',

    'backoffice.navigation.modal.signout.title': 'Do you want to sign out?',
    'backoffice.navigation.modal.signout.ok': 'Yes',
    'backoffice.navigation.modal.signout.cancel': 'No',

    'backoffice.common.reupload.label': 'Change an image',
    'backoffice.common.upload.label': 'Upload an image',
    'backoffice.common.save.label': 'Save',
    'backoffice.common.delete.label': 'Delete',
    'backoffice.common.fetch.fail': 'Unable to fetch data',

    // Articles
    'backoffice.breadcrumbs.articles': 'All articles',
    'backoffice.breadcrumbs.articles.edit': 'Edit',
    'backoffice.breadcrumbs.articles.new': 'New article',

    'backoffice.articles.modal.delete.title': 'Are you sure you want to delete?',
    'backoffice.articles.modal.delete.ok': 'Confirm',
    'backoffice.articles.modal.delete.cancel': 'Cancel',

    'backoffice.articles.list.add.button': 'Add an article',
    'backoffice.articles.list.edit.button': 'Edit',
    'backoffice.articles.list.no.data': 'No articles',
    'backoffice.articles.list.no.column': 'No',
    'backoffice.articles.list.image.column': 'Image',
    'backoffice.articles.list.title.column': 'Title',
    'backoffice.articles.list.date.column': 'Date',
    'backoffice.articles.list.view.column': 'Views',
    'backoffice.articles.list.action.column': 'Actions',

    'backoffice.articles.detail.title': 'Article Detail',
    'backoffice.articles.detail.input.title': 'Title (Thai)',
    'backoffice.articles.detail.input.title.en': 'Title (English)',
    'backoffice.articles.detail.input.excerpt': 'Excerpt (Thai)',
    'backoffice.articles.detail.input.excerpt.en': 'Excerpt (English)',
    'backoffice.articles.detail.input.content': 'Content (Thai)',
    'backoffice.articles.detail.input.content.en': 'Content (English)',
    'backoffice.articles.detail.cover.image.title': 'Cover Image',
    'backoffice.articles.detail.input.cover.image': 'Upload an image',
    'backoffice.articles.detail.input.featured': 'Featured',
    'backoffice.articles.detail.input.category': 'Categories',
    'backoffice.articles.save.success': 'Save the article successfully',
    'backoffice.articles.save.fail': 'Cannot save the article',
    'backoffice.articles.delete.success': 'Delete the article successfully',
    'backoffice.articles.delete.fail': 'Cannot delete the article',

    // Stores
    'backoffice.breadcrumbs.stores': 'All stores',
    'backoffice.breadcrumbs.stores.edit': 'Edit',
    'backoffice.breadcrumbs.stores.new': 'Add a store',

    'backoffice.stores.modal.delete.title': 'Are you sure you want to delete?',
    'backoffice.stores.modal.delete.ok': 'Confirm',
    'backoffice.stores.modal.delete.cancel': 'Cancel',

    'backoffice.stores.list.add.button': 'Add a store',
    'backoffice.stores.list.edit.button': 'Edit',
    'backoffice.stores.list.no.data': 'No stores',
    'backoffice.stores.list.no.column': 'No',
    'backoffice.stores.list.image.column': 'Image',
    'backoffice.stores.list.title.column': 'Title',
    'backoffice.stores.list.date.column': 'Date',
    'backoffice.stores.list.action.column': 'Actions',

    'backoffice.stores.detail.input.location.name': 'Location Name (Thai)',
    'backoffice.stores.detail.input.location.name.en': 'Location Name (English)',
    'backoffice.stores.detail.input.url': 'URL',
    'backoffice.stores.detail.input.image': 'Image',
    'backoffice.stores.save.success': 'Save the store successfully',
    'backoffice.stores.save.fail': 'Cannot save the store',
    'backoffice.stores.delete.success': 'Delete the store successfully',
    'backoffice.stores.delete.fail': 'Cannot delete the store',

    // Products
    'backoffice.breadcrumbs.products': 'All products',
    'backoffice.breadcrumbs.products.edit': 'Edit',
    'backoffice.breadcrumbs.products.new': 'Add a product',

    'backoffice.products.modal.delete.title': 'Are you sure you want to delete?',
    'backoffice.products.modal.delete.ok': 'Confirm',
    'backoffice.products.modal.delete.cancel': 'Cancel',

    'backoffice.products.list.add.button': 'Add a product',
    'backoffice.products.list.edit.button': 'Edit',
    'backoffice.products.list.no.data': 'No products',
    'backoffice.products.list.no.column': 'No',
    'backoffice.products.list.image.column': 'Image',
    'backoffice.products.list.title.column': 'Title',
    'backoffice.products.list.list.column': 'List',
    'backoffice.products.list.view.column': 'Views',
    'backoffice.products.list.date.column': 'Date',
    'backoffice.products.list.action.column': '',

    'backoffice.products.detail.input.distribution': 'Stores',
    'backoffice.products.detail.input.category': 'Categories',
    'backoffice.products.detail.input.name': 'Product Name',
    'backoffice.products.detail.input.name.en': 'Name (English)',
    'backoffice.products.detail.input.information': 'Product Detail',
    'backoffice.products.detail.input.information.en': 'Content (English)',
    'backoffice.products.detail.input.description': 'Short Description (Thai)',
    'backoffice.products.detail.input.description.en': 'Short Description (English)',
    'backoffice.products.detail.input.price': 'Price',
    'backoffice.products.detail.input.fda.number': 'FDA Number',
    'backoffice.products.detail.input.image': 'Upload Image',
    'backoffice.products.detail.input.is.discount': 'Sale',
    'backoffice.products.detail.input.discount': 'Discount',
    'backoffice.products.detail.input.featured': 'Featured',

    'backoffice.products.save.success': 'Save the product successfully',
    'backoffice.products.save.fail': 'Cannot save the product',
    'backoffice.products.delete.success': 'Delete the product successfully',
    'backoffice.products.delete.fail': 'Cannot delete the product',

    // About
    'backoffice.breadcrumbs.about': 'About Company',
    'backoffice.breadcrumbs.about.edit': 'Edit',
    'backoffice.about.edit.button': 'Edit',

    'backoffice.about.edit.input.company.name': 'Company Name (Thai)',
    'backoffice.about.edit.input.company.name.en': 'Company Name (English)',
    'backoffice.about.edit.input.logo.image': 'Company Logo',
    'backoffice.about.edit.input.logo.image.white': 'Company Logo (White Color)',
    'backoffice.about.edit.input.company.image': 'Company Image',
    'backoffice.about.edit.input.content': 'Content (Thai)',
    'backoffice.about.edit.input.content.en': 'Content (English)',
    'backoffice.about.edit.input.icons': 'Standard Icons',
    'backoffice.about.edit.input.icon.set.image': 'Standard Icon Image',
    'backoffice.about.edit.input.icon.set.text': 'Standard Icon Text (Thai)',
    'backoffice.about.edit.input.icon.set.text.en': 'Standard Icon Text (English)',
    'backoffice.about.edit.input.product.image': 'Background Image',
    'backoffice.about.save.success': 'Save company information successfully',
    'backoffice.about.save.fail': 'Cannot save campany information',

    // Contact
    'backoffice.breadcrumbs.contact': 'Contact',
    'backoffice.breadcrumbs.contact.image': 'Upload image',
    'backoffice.breadcrumbs.contact.edit': 'Edit',

    'backoffice.contact.edit.button': 'Edit',
    'backoffice.contact.edit.input.address': 'Address (Thai)',
    'backoffice.contact.edit.input.address.en': 'Address (English)',
    'backoffice.contact.edit.input.email': 'Email',
    'backoffice.contact.edit.input.facebook': 'Facebook',
    'backoffice.contact.edit.input.line.id': 'LINE ID',
    'backoffice.contact.edit.input.phone.number': 'Phone',
    'backoffice.contact.edit.input.twitter': 'Twitter',
    'backoffice.contact.edit.input.youtube': 'Youtube',
    'backoffice.contact.save.success': 'Save contact successfully',
    'backoffice.contact.save.fail': 'Cannot save contact',

    // Categories
    'backoffice.breadcrumbs.categories': 'Categories',
    'backoffice.breadcrumbs.categories.new': 'New Category',
    'backoffice.breadcrumbs.categories.edit': 'Edit',
    'backoffice.categories.list.add.button': 'Add',
    'backoffice.categories.list.no.data': 'No Categories',
    'backoffice.categories.list.no.column': 'No',
    'backoffice.categories.list.title.column': 'Title',
    'backoffice.categories.list.action.column': 'Actions',
    'backoffice.categories.list.edit.button': 'Edit',

    'backoffice.categories.detail.input.category.name': 'Category Name',
    'backoffice.categories.save.success': 'Save the category successfully',
    'backoffice.categories.save.fail': 'Cannot save the category',
    'backoffice.categories.modal.delete.title': 'Are you sure you want to delete?',
    'backoffice.categories.modal.delete.ok': 'Yes',
    'backoffice.categories.modal.delete.cancel': 'No',
    'backoffice.categories.delete.success': 'Delete the category successfully',
    'backoffice.categories.delete.fail': 'Cannot delete the category'
  },
  th_TH: {
    'breadcrumbs.home': 'หน้าแรก',
    'breadcrumbs.products': 'ผลิตภัณฑ์',
    'breadcrumbs.articles': 'บทความ',
    'breadcrumbs.about': 'เกี่ยวกับเรา',
    'breadcrumbs.contact': 'ติดต่อเรา',
    'breadcrumbs.seller': 'ช่องทางการสั่งซื้อ',
    'navigation.home': 'หน้าแรก',
    'navigation.products': 'ผลิตภัณฑ์',
    'navigation.articles': 'บทความ',
    'navigation.about': 'เกี่ยวกับเรา',
    'navigation.contact': 'ติดต่อเรา',
    'navigation.tel': 'โทร',
    'home.title.1': 'เราคือผู้เชี่ยวชาญ',
    'home.title.2': 'ด้านการดูแลสุขภาพ',
    'home.readmore.button': 'อ่านทั้งหมด',
    'home.products.label': 'ผลิตภัณฑ์',
    'home.products.view.all.button': 'ดูสินค้าทั้งหมด',
    'home.articles.label': 'เคล็ดลับน่ารู้ดูแลสุขภาพ',
    'home.articles.view.all.button': 'ดูบทความทั้งหมด',
    'standard.label': 'มีมาตรฐานการผลิต',
    'seller.label': 'วางจำหน่ายแล้วที่',
    'products.all.products.label': 'ผลิตภัณฑ์ทั้งหมด',
    'products.loadmore.button': 'โหลดเพิ่มเติม',
    'products.seller.button': 'ช่องทางการสั่งซื้อ',
    'products.fda.label': 'เลขอย.',
    'products.related.products.label': 'สินค้าที่เกี่ยวข้อง',
    'products.no.related.products.label': 'ไม่พบสินค้าที่เกี่ยวข้อง',
    'sellers.title': 'ช่องทางการสั่งซื้อ',
    'article.read.more.button': 'อ่านเพิ่มเติม',
    'articles.label': 'เคล็ดลับน่ารู้ดูแลสุขภาพ',
    'articles.loadmore.button': 'โหลดเพิ่มเติม',
    'articles.related.articles': 'บทความที่เกี่ยวข้อง',
    'articles.no.related.articles': 'ไม่พบบทความที่เกี่ยวข้อง',
    'contact.title': 'ช่องทางการติดต่อเรา',
    'contact.tel': 'โทร',
    'contact.email': 'อีเมล์',
    'contact.join.us': 'สนใจเป็นตัวแทนจำหน่ายติดต่อ',
    'quill.cannot.upload.image': 'ไม่สามารถอัพโหลดรูปได้',

    'snackbar.ok.text': 'ตกลง',
    'snackbar.error.message': 'เกิดข้อผิดพลาด',

    'backoffice.navigation.signout': 'ออกจากระบบ',

    'backoffice.sidebar.title': 'ตั้งค่า',
    'backoffice.sidebar.articles': 'บทความ',
    'backoffice.sidebar.about': 'ข้อมูลเกี่ยวกับบริษัท',
    'backoffice.sidebar.contact': 'ข้อมูลติดต่อเรา',
    'backoffice.sidebar.seller': 'ช่องทางการจัดจำหน่าย',
    'backoffice.sidebar.category': 'หมวดหมู่',
    'backoffice.sidebar.products': 'ข้อมูลผลิตภัณฑ์',
    'backoffice.sidebar.orders': 'ข้อมูลรายการ',

    'backoffice.navigation.modal.signout.title': 'ต้องการออกจากระบบหรือไม่',
    'backoffice.navigation.modal.signout.ok': 'ใช่',
    'backoffice.navigation.modal.signout.cancel': 'ไม่ใช่',

    'backoffice.common.reupload.label': 'อัพโหลดรูปภาพใหม่',
    'backoffice.common.upload.label': 'อัพโหลดรูปภาพ',
    'backoffice.common.save.label': 'บันทึก',
    'backoffice.common.delete.label': 'ลบ',
    'backoffice.common.fetch.fail': 'ไม่สามารถโหลดข้อมูลได้',

    // Articles
    'backoffice.breadcrumbs.articles': 'บทความทั้งหมด',
    'backoffice.breadcrumbs.articles.edit': 'แก้ไข',
    'backoffice.breadcrumbs.articles.new': 'บทความใหม่',

    'backoffice.articles.modal.delete.title': 'ต้องการลบบทความนี้ใช่หรือไม่',
    'backoffice.articles.modal.delete.ok': 'ใช่',
    'backoffice.articles.modal.delete.cancel': 'ไม่ใช่',

    'backoffice.articles.list.add.button': 'เพิ่มบทความ',
    'backoffice.articles.list.edit.button': 'แก้ไข',
    'backoffice.articles.list.no.data': 'ยังไม่มีบทความ',
    'backoffice.articles.list.no.column': 'ลำดับ',
    'backoffice.articles.list.image.column': 'รูปภาพ',
    'backoffice.articles.list.title.column': 'รายการ',
    'backoffice.articles.list.date.column': 'วันที่',
    'backoffice.articles.list.view.column': 'จำนวนการเข้าชม',
    'backoffice.articles.list.action.column': 'ปรับแต่ง',

    'backoffice.articles.detail.title': 'ข้อมูลบทความ',
    'backoffice.articles.detail.input.title': 'หัวข้อ (ภาษาไทย)',
    'backoffice.articles.detail.input.title.en': 'หัวข้อ (ภาษาอังกฤษ)',
    'backoffice.articles.detail.input.excerpt': 'คำขึ้นต้นเนื้อหา (ภาษาไทย)',
    'backoffice.articles.detail.input.excerpt.en': 'คำขึ้นต้นเนื้อหา (ภาษาอังกฤษ)',
    'backoffice.articles.detail.input.content': 'ข้อมูลเนื้อหา (ภาษาไทย)',
    'backoffice.articles.detail.input.content.en': 'ข้อมูลเนื้อหา (ภาษาอังกฤษ)',
    'backoffice.articles.detail.cover.image.title': 'รูปภาพหน้าปก',
    'backoffice.articles.detail.input.cover.image': 'อัพโหลดรูปภาพ',
    'backoffice.articles.detail.input.featured': 'บทความแนะนำ',
    'backoffice.articles.detail.input.category': 'หมวดหมู่',
    'backoffice.articles.save.success': 'บันทึกบทความสำเร็จ',
    'backoffice.articles.save.fail': 'ไม่สามารถันทึกบทความได้',
    'backoffice.articles.delete.success': 'ลบบทความสำเร็จ',
    'backoffice.articles.delete.fail': 'ไม่สามารถลบบทความได้',

    // Stores
    'backoffice.breadcrumbs.stores': 'ช่องทางการจำหน่ายทั้งหมด',
    'backoffice.breadcrumbs.stores.edit': 'แก้ไข',
    'backoffice.breadcrumbs.stores.new': 'ช่องทางการจำหน่ายใหม่',

    'backoffice.stores.modal.delete.title': 'ต้องการลบช่องทางการจำหน่ายนี้ใช่หรือไม่',
    'backoffice.stores.modal.delete.ok': 'ใช่',
    'backoffice.stores.modal.delete.cancel': 'ไม่ใช่',

    'backoffice.stores.list.add.button': 'เพิ่มช่องทางการจำหน่าย',
    'backoffice.stores.list.edit.button': 'แก้ไข',
    'backoffice.stores.list.no.data': 'ยังไม่มีช่องทางการจำหน่าย',
    'backoffice.stores.list.no.column': 'ลำดับ',
    'backoffice.stores.list.image.column': 'รูป',
    'backoffice.stores.list.title.column': 'รายการ',
    'backoffice.stores.list.date.column': 'วันที่',
    'backoffice.stores.list.view.column': 'จำนวนการเข้าชม',
    'backoffice.stores.list.action.column': 'ปรับแต่ง',

    'backoffice.stores.detail.input.location.name': 'ชื่อสถานที่ (ภาษาไทย)',
    'backoffice.stores.detail.input.location.name.en': 'ชื่อสถานที่ (ภาษาอังกฤษ)',
    'backoffice.stores.detail.input.url': 'URL',
    'backoffice.stores.detail.input.image': 'รูปภาพ',
    'backoffice.stores.save.success': 'บันทึกช่องทางการจำหน่าสำเร็จ',
    'backoffice.stores.save.fail': 'ไม่สามารถบันทึกช่องทางการจำหน่ายได้',
    'backoffice.stores.delete.success': 'ลบช่องทางการจำหน่ายสำเร็จ',
    'backoffice.stores.delete.fail': 'ไม่สามารถลบช่องทางการจำหน่ายได้',

    // Products
    'backoffice.breadcrumbs.products': 'ผลิตภัณฑ์ทั้งหมด',
    'backoffice.breadcrumbs.products.edit': 'แก้ไข',
    'backoffice.breadcrumbs.products.new': 'ผลิตภัณฑ์ใหม่',

    'backoffice.products.modal.delete.title': 'ต้องการลบผลิตภัณฑ์นี้ใช่หรือไม่',
    'backoffice.products.modal.delete.ok': 'ใช่',
    'backoffice.products.modal.delete.cancel': 'ไม่ใช่',

    'backoffice.products.list.add.button': 'เพิ่มผลิตภัณฑ์',
    'backoffice.products.list.edit.button': 'แก้ไข',
    'backoffice.products.list.no.data': 'ไม่พบผลิตภัณฑ์',
    'backoffice.products.list.no.column': 'ลำดับ',
    'backoffice.products.list.image.column': 'รูปภาพ',
    'backoffice.products.list.title.column': 'รายการ',
    'backoffice.products.list.view.column': 'จำนวนการเข้าชม',
    'backoffice.products.list.date.column': 'วันที่',
    'backoffice.products.list.action.column': 'ปรับแต่ง',

    'backoffice.products.detail.input.distribution': 'ช่องทางการจัดจำหน่าย',
    'backoffice.products.detail.input.category': 'หมวดหมู่',
    'backoffice.products.detail.input.name': 'ชื่อผลิตภัณฑ์ (ภาษาไทย)',
    'backoffice.products.detail.input.name.en': 'ชื่อผลิตภัณฑ์ (ภาษาอังกฤษ)',
    'backoffice.products.detail.input.information': 'ข้อมูลผลิตภัณฑ์ (ภาษาไทย)',
    'backoffice.products.detail.input.information.en': 'ข้อมูลผลิตภัณฑ์ (ภาษาอังกฤษ)',
    'backoffice.products.detail.input.description': 'รายละเอียดผลิตภัณฑ์ (ภาษาไทย)',
    'backoffice.products.detail.input.description.en': 'รายละเอียดผลิตภัณฑ์ (ภาษาอังกฤษ)',
    'backoffice.products.detail.input.price': 'ราคา',
    'backoffice.products.detail.input.fda.number': 'เลข อย.',
    'backoffice.products.detail.input.image': 'รูปภาพ',
    'backoffice.products.detail.input.is.discount': 'ใช้งานส่วนลด',
    'backoffice.products.detail.input.discount': 'ราคาที่ลดแล้ว',
    'backoffice.products.detail.input.featured': 'สินค้าแนะนำ',

    'backoffice.products.save.success': 'บันทึกผลิตภัณฑ์สำเร็จ',
    'backoffice.products.save.fail': 'ไม่สามารถบันทึกผลิตภัณฑ์',
    'backoffice.products.delete.success': 'ลบผลิตภัณฑ์สำเร็จ',
    'backoffice.products.delete.fail': 'ไม่สามารถลบผลิตภัณฑ์',

    // About
    'backoffice.breadcrumbs.about': 'ข้อมูลเกี่ยวกับบริษัท',
    'backoffice.breadcrumbs.about.edit': 'แก้ไข',
    'backoffice.about.edit.button': 'แก้ไข',

    'backoffice.about.edit.input.company.name': 'ชื่อบริษัท (ภาษาไทย)',
    'backoffice.about.edit.input.company.name.en': 'ชื่อบริษัท (ภาษาอังกฤษ)',
    'backoffice.about.edit.input.logo.image': 'โลโก้บริษัท',
    'backoffice.about.edit.input.logo.image.white': 'โลโก้บริษัท (สีขาว)',
    'backoffice.about.edit.input.company.image': 'ภาพบริษัท',
    'backoffice.about.edit.input.content': 'ข้อมูลเนื้อหา (ภาษาไทย)',
    'backoffice.about.edit.input.content.en': 'ข้อมูลเนื้อหา (ภาษาอังกฤษ)',
    'backoffice.about.edit.input.icons': 'อัพโหลดไอคอน',
    'backoffice.about.edit.input.icon.set.image': 'รูปไอคอน',
    'backoffice.about.edit.input.icon.set.text': 'ชื่อไอคอน (ภาษาไทย)',
    'backoffice.about.edit.input.icon.set.text.en': 'ชื่อไอคอน (ภาษาอังกฤษ)',
    'backoffice.about.edit.input.product.image': 'ภาพพื้นหลัง',
    'backoffice.about.save.success': 'บันทึกข้อมูลบริษัทสำเร็จ',
    'backoffice.about.save.fail': 'ไม่สามารถบันทึกข้อมูลบริษัท',

    // Contact
    'backoffice.breadcrumbs.contact': 'ข้อมูลติดต่อเรา',
    'backoffice.breadcrumbs.contact.edit': 'แก้ไข',

    'backoffice.contact.edit.button': 'แก้ไข',
    'backoffice.contact.edit.input.address': 'ที่อยู่ (ภาษาไทย)',
    'backoffice.contact.edit.input.address.en': 'ที่อยู่ (ภาษาอังกฤษ)',
    'backoffice.contact.edit.input.email': 'Email',
    'backoffice.contact.edit.input.facebook': 'Facebook',
    'backoffice.contact.edit.input.line.id': 'ไอดี LINE',
    'backoffice.contact.edit.input.phone.number': 'เบอร์โทรศัพท์',
    'backoffice.contact.edit.input.twitter': 'Twitter',
    'backoffice.contact.edit.input.youtube': 'Youtube',
    'backoffice.contact.save.success': 'บันทึกช่องทางการติดต่อสำเร็จ',
    'backoffice.contact.save.fail': 'ไม่สามารถบันทึกช่องทางการติดต่อได้',

    // Categories
    'backoffice.breadcrumbs.categories': 'หมวดหมู่',
    'backoffice.breadcrumbs.categories.new': 'หมวดหมู่ใหม่',
    'backoffice.breadcrumbs.categories.edit': 'แก้ไข',
    'backoffice.categories.list.add.button': 'เพิ่ม',
    'backoffice.categories.list.no.data': 'ไม่พบหมวดหมู่',
    'backoffice.categories.list.no.column': 'ลำดับ',
    'backoffice.categories.list.title.column': 'รายการ',
    'backoffice.categories.list.action.column': 'ปรับแต่ง',
    'backoffice.categories.list.edit.button': 'แก้ไข',

    'backoffice.categories.detail.input.category.name': 'ชื่อหมวดหมู่',
    'backoffice.categories.save.success': 'บันทึกหมวดหมู่สำเร็จ',
    'backoffice.categories.save.fail': 'ไม่สามารถบันทึกหมวดหมู่ได้',
    'backoffice.categories.modal.delete.title': 'ต้องการลบหมวดหมู่นี้หรือไม่',
    'backoffice.categories.modal.delete.ok': 'ใช่',
    'backoffice.categories.modal.delete.cancel': 'ไม่ใช่',
    'backoffice.categories.delete.success': 'ลบหมวดหมู่สำเร็จ',
    'backoffice.categories.delete.fail': 'ไม่สามารถลบหมวดหมู่ได้'
  },
};
